import React from "react";
import FooterLink, { KontentFooterLink } from "./FooterLink";

interface LinkGroupProps {
  titleLink?: KontentFooterLink;
  nonLinkTitle?: string;
  subLinks: KontentFooterLink[];
}

const LinkGroup = ({ titleLink, nonLinkTitle, subLinks }: LinkGroupProps) => {
  return (
    <ul className="flex flex-col gap-y-1.5">
      {nonLinkTitle && (
        <li className="max-w-min font-heading text-2xl tracking-[1.44px] text-white">
          {nonLinkTitle}
        </li>
      )}
      {titleLink && (
        <li>
          <FooterLink
            internalPath={titleLink.elements.internal_path.value}
            externalUrl={titleLink.elements.external_url.value}
            new_window={titleLink.elements.new_window.value[0]?.codename}
            variant="title"
          >
            {titleLink.elements.text.value}
          </FooterLink>
        </li>
      )}
      {subLinks &&
        subLinks.map((link, idx: number) => (
          <li key={idx} className="ml-3">
            <FooterLink
              internalPath={link.elements.internal_path.value}
              externalUrl={link.elements.external_url.value}
              new_window={link.elements.new_window.value[0]?.codename}
              variant="subLink"
            >
              {link.elements.text.value}
            </FooterLink>
          </li>
        ))}
    </ul>
  );
};

export default LinkGroup;

export type KontentLinkGroup = {
  elements: {
    non_link_title: { value: string };
    title_link: { value: KontentFooterLink[] };
    sub_links: { value: KontentFooterLink[] };
  };
};
